export const ServiceType = {
  package: 0,
  roundTrip: 1,
  singleTrip: 2,
  hotel: 3,
  excursion: 4,
  extraService: 5,
  insurance: 6,
  flight: 7,
  serviceFee: 8,
  visum: 9,
  charter: 10,
  cruise: 11,
  ferry: 12,
  transfer: 13,
  bus: 14,
  tax: 15,
  fee: 16,
  car: 17,
  camper: 18,
  specialServices: 19,
  train: 20,
  gift: 21,
  rental: 22,
  restaurant: 23,
  event: 24,
  training: 25,
  voucher: 26,
  reduction: 27,
  rocket: 28,
  tent: 29,
  camp: 30,
};
